import { STORAGE_KEYS } from '../data/constants'

const TOKEN_KEY = STORAGE_KEYS.token
const USER_KEY = STORAGE_KEYS.user
const PERSIST_KEY = STORAGE_KEYS.persist

function readFrom(store) {
  const token = store.getItem(TOKEN_KEY)
  const rawUser = store.getItem(USER_KEY)
  if (!token || !rawUser) return null
  try {
    return { token, user: JSON.parse(rawUser) }
  } catch {
    return null
  }
}

export function clearSession() {
  ;[localStorage, sessionStorage].forEach((store) => {
    store.removeItem(TOKEN_KEY)
    store.removeItem(USER_KEY)
  })
  localStorage.removeItem(PERSIST_KEY)
}

export function writeSession(user, token, remember) {
  const store = remember ? localStorage : sessionStorage
  const other = remember ? sessionStorage : localStorage
  other.removeItem(TOKEN_KEY)
  other.removeItem(USER_KEY)
  store.setItem(TOKEN_KEY, token)
  store.setItem(USER_KEY, JSON.stringify(user))
  localStorage.setItem(PERSIST_KEY, remember ? '1' : '0')
}

export function getStoredSession() {
  return readFrom(localStorage) || readFrom(sessionStorage)
}

export function getToken() {
  return getStoredSession()?.token || ''
}

export function getCurrentUser() {
  return getStoredSession()?.user || null
}

export function isRemembered() {
  const flag = localStorage.getItem(PERSIST_KEY)
  if (flag === '1') return true
  if (flag === '0') return false
  return Boolean(readFrom(localStorage)?.token)
}
